/**
 * 로그인 리다이렉트 목적지 검증 — URL 쿼리로 들어오는 값이라 신뢰 경계다.
 * 앱 내부 경로(`/...`)만 통과시켜 오픈 리다이렉트를 막는다.
 * `//evil` `/\evil` 은 브라우저가 프로토콜 상대 URL 로 해석하므로 내부 경로가 아니다.
 */
function hasControlOrSpace(value: string): boolean {
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i);
    if (code <= 0x20 || code === 0x7f) return true;
  }
  return false;
}

export function safeInternalPath(value: unknown): string | undefined {
  if (typeof value !== 'string' || value === '') return undefined;
  if (value[0] !== '/') return undefined;
  if (value[1] === '/' || value[1] === '\\') return undefined;
  if (hasControlOrSpace(value)) return undefined;
  return value;
}
